import CollegePillActions from './constants';
import { IActionObject } from './types';

export function addCollegePill(pill: {
  value: string;
  label: string;
}): IActionObject {
  return {
    type: CollegePillActions.ADD_COLLEGE_PILL,
    data: { value: pill.value, label: pill.label },
  };
}

export function removeCollegePill(pill: { value: string }): IActionObject {
  return {
    type: CollegePillActions.REMOVE_COLLEGE_PILL,
    data: { value: pill.value },
  };
}
try {
    // @ts-ignore
    addCollegePill.displayName = "addCollegePill";
    // @ts-ignore
    addCollegePill.__docgenInfo = { "description": "", "displayName": "addCollegePill", "props": { "value": { "defaultValue": null, "description": "", "name": "value", "required": true, "type": { "name": "string" } }, "label": { "defaultValue": null, "description": "", "name": "label", "required": true, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/store/collegePill/actions.tsx#addCollegePill"] = { docgenInfo: addCollegePill.__docgenInfo, name: "addCollegePill", path: "src/store/collegePill/actions.tsx#addCollegePill" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    removeCollegePill.displayName = "removeCollegePill";
    // @ts-ignore
    removeCollegePill.__docgenInfo = { "description": "", "displayName": "removeCollegePill", "props": { "value": { "defaultValue": null, "description": "", "name": "value", "required": true, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/store/collegePill/actions.tsx#removeCollegePill"] = { docgenInfo: removeCollegePill.__docgenInfo, name: "removeCollegePill", path: "src/store/collegePill/actions.tsx#removeCollegePill" };
}
catch (__react_docgen_typescript_loader_error) { }